import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async () => {
        APP_COMPONENTS.showsForms.add();
    }
};
